import Axios from '@/utils/axios'

const URL = '/usuarios'

export default {
  show: () =>
    Axios.get(`${URL}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0'
      }
    }),
  showDadosBasicos: () =>
    Axios.get(`${URL}/dados-basicos`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0'
      }
    }),
  changePassword: ({ currentPassword, newPassword }) =>
    Axios.post(`${URL}/change-password`, { currentPassword, newPassword }),
  update: params => Axios.put(`${URL}`, params),
  updateDadosBasicos: params => Axios.put(`${URL}/dados-basicos`, params)
}
